import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import { RefreshToken } from './Session';
import { useSearchParams } from "react-router-dom";
import { useAuthDataContext } from "../AuthDataProvider";
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export default function RefreshLoginPage() {
  const { user, onLogin, onLogout } = useAuthDataContext();

  const [redirectURL, setRedirectURL] = useState(null);
  const [searchParams] = useSearchParams();

  const redirect = searchParams.get('redirect');

  useEffect(() => {
    let isMounted = true; // Track if the component is still mounted


    let sessionUser = user;
    if (sessionUser == null) {
      const cookie = Cookies.get("__session");
      sessionUser = cookie ? jwtDecode(cookie) : null;
    }

    if (sessionUser == null) {
      setRedirectURL("/login");
    } else {
      RefreshToken(sessionUser.refresh_token)
        .then((result) => {
          if (isMounted) {
            onLogin(result);
            setRedirectURL(redirect);
          }
        })
        .catch((error) => {
          if (isMounted) {
            console.log(error);
            onLogout();
            setRedirectURL("/login");
          }
        });
    }

    return () => {
      isMounted = false; // Cleanup function to prevent state updates if unmounted
    };
  }, []);

  if (redirectURL) {
    window.location.href = redirectURL;
    return null;
  } else {
    return (
      <Container maxWidth="lg" className="container">
        <br />
        <Paper spacing={3}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '25vh' }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <h1>Refresh Token</h1>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <CircularProgress size={48} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }
}